import {virtualCurrencyRepository} from '@/repositories/Index';


class VirtualCurrencyService {
    // 获取酒店账户带客金立即领取、使用带客金、暂停使用带客金、加金币按钮限制
    async getHotelAccountButtonFn() {
      const res = await virtualCurrencyRepository.getHotelAccountButton();
      return res;
    }

    //带客金订单创建
    async createDaikebiFn(params:any) {
        const res = await virtualCurrencyRepository.createDaikebi(params);
        return res;
    }
    //带客金营业额增幅图
    async turnoverIncreaseChartFn(params:any) {
        const res = await virtualCurrencyRepository.turnoverIncreaseChart(params);
        return res;
    }
    //酒店领取带客金
    async hotelReceiveCoinFn(params:any) {
        const res = await virtualCurrencyRepository.hotelReceiveCoin(params);
        return res;
    }
    //获取酒店数据概览
    async getHotelDataOverviewFn() {
        const res = await virtualCurrencyRepository.getHotelDataOverview();
        return res;
    }
    //带客金酒店账户概览
    async getHotelAccountInfoFn() {
        const res = await virtualCurrencyRepository.getHotelAccountInfo();
        return res;
    }
    //带客金订单修改
    async modifyDaikebiFn(params:any) {
        const res = await virtualCurrencyRepository.modifyDaikebi(params);
        return res;
    }
    //带客金推广计划订单状态变更
    async daiKeBiStatusChangeFn(params:any) {
        const res = await virtualCurrencyRepository.daiKeBiStatusChange(params);
        return res;
    }
    //获取cpc推广订单详情
    async getCpcAdDetailFn(params:any) {
        const res = await virtualCurrencyRepository.getCpcAdDetail(params);
        return res;
    }
    //酒店账户阶梯进度
    async hotelAccountProgressFn() {
        const res = await virtualCurrencyRepository.hotelAccountProgress();
        return res;
    }
    //cpc推广计划日志查询
    async getJournalDetailFn(params:any) {
        const res = await virtualCurrencyRepository.getJournalDetail(params);
        return res;
    }
    //带客金酒店待领取订单集合
    async getWaitDrawOrderListFn(params:any) {
        const res = await virtualCurrencyRepository.getWaitDrawOrderList(params);
        return res;
    }
    //带客金酒店待领取订单集合下载
    async exportWaitDrawOrderListFn(params:any) {
        const res = await virtualCurrencyRepository.exportWaitDrawOrderList(params);
        return res;
    }
    //带客金酒店充值记录集合
    async getRechargeOrderListFn(params:any) {
        const res = await virtualCurrencyRepository.getRechargeOrderList(params);
        return res;
    }
    //带客金酒店充值记录集合下载
    async exportRechargeOrderListFn(params:any) {
        const res = await virtualCurrencyRepository.exportRechargeOrderList(params);
        return res;
    }
    //带客金酒店消耗记录集合
    async getConsumeOrderListFn(params:any) {
        const res = await virtualCurrencyRepository.getConsumeOrderList(params);
        return res;
    }
    //带客金酒店消耗记录集合下载
    async exportConsumeOrderListFn(params:any) {
        const res = await virtualCurrencyRepository.exportConsumeOrderList(params);
        return res;
    }
    //带客金可带来订单收入预估
    async daikebiOrderIncomeForecastFn() {
        const res = await virtualCurrencyRepository.daikebiOrderIncomeForecast();
        return res;
    }

    async modifySmartDeliveryDaikebi(params:any) {
        const res = await virtualCurrencyRepository.modifySmartDeliveryDaikebi(params);
        return res;
    }

    async smartDeliveryForecast(params:any) {
        const res = await virtualCurrencyRepository.smartDeliveryForecast(params);
        return res;
    }

    async autoReceiveCoin(params:any) {
        const res = await virtualCurrencyRepository.autoReceiveCoin(params);
        return res;
    }

    async popWindow(params:any) {
        const res = await virtualCurrencyRepository.popWindow(params);
        return res;
    }

    async getConfig() {
        const res = await virtualCurrencyRepository.getConfig();
        return res;
    }
    
  }
  
  export default VirtualCurrencyService;
  